export const DELIVERY_METHOD = {
  delivery: 'delivery',
  selfPickup: 'self_pickup',
} as const;

export const MIN_COST_DELIVERY_FREE = 5000;
export const DELIVERY_DESCRIPTION = {
  free: 'У вас бесплатная доставка по Москве.',
  less: `до Бесплатной доставки по Москве. Доставка рассчитывается в Оформлении заказа`,
};
